import React from "react";

import { twMerge } from "tailwind-merge";

import useMediaQuery from "hooks/useMediaQuery";

import useSegmentTabs from "./useSegmentTabs";

type Props = {
  tabs: any;
  onChangeTab: (_tab: any) => void;
  className?: string;
  itemClassName?: string;
  activeTabId: string;
  type?: "rounded" | "flat";
};

function SegmentTabs({
  tabs = [],
  activeTabId,
  onChangeTab,
  className,
  itemClassName,
  type,
}: Props) {
  const { changeActiveTab, allTabs } = useSegmentTabs({
    activeTabId,
    tabs,
    onChangeTab,
  });

  const { mobile } = useMediaQuery();

  if (type === "flat") {
    const tabsList = allTabs.current.map((tab: any) => (
      <div
        key={tab.id}
        onClick={() => changeActiveTab(tab)}
        className={twMerge(
          "flex-1",
          mobile && "text-nowrap",
          "px-[15px] pt-[13px] pb-[10px]",
          "cursor-pointer",
          "hover:text-smart-teal",
          itemClassName,
          activeTabId === tab.id &&
            "border-0 border-b-[3px] border-solid border-ink-pink"
        )}
      >
        {tab.title}
      </div>
    ));

    return (
      <div
        className={twMerge(
          "bg-[whitesmoke]",
          "flex overflow-x-scroll",
          "text-center",
          "text-active-black",
          "text-[15px]",
          className
        )}
      >
        {tabsList}
      </div>
    );
  }

  const tabsList = allTabs.current.map((tab: any) => (
    <div
      key={tab.id}
      onClick={() => changeActiveTab(tab)}
      dangerouslySetInnerHTML={{ __html: tab.title }}
      className={twMerge(
        "flex-1",
        "cursor-pointer",
        itemClassName,
        activeTabId === tab.id && "bg-white rounded-[4px] shadow font-medium"
      )}
    />
  ));

  return (
    <div
      className={twMerge(
        "rounded-[6px]",
        "bg-[#eee]",
        "flex",
        "text-center",
        "text-[#1f1f20]",
        "text-[12px]",
        "p-[3px]",
        className
      )}
    >
      {tabsList}
    </div>
  );
}

export default SegmentTabs;
